import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { flashMessage as flash } from "../../../utils/flash";
import customerService from "./customerService";

const initialState = {
  customers: {
    individual: null,
    corperate: null,
  },
  single_customer: {},
  attachPolicy_customer: null,
  application_info: {
    current_tab: "step-1",
  },
  unpaginated_customers: null,
  isLoading: false,
  isSuccess: false,
  isUpdateSuccess: false,
  isFetching: false,
  isSearching: false,
  isFiltered: false,
  isFiltering: false,
  isError: false,
  message: "",
  newCustomer_id: null,
  customer_active_policy: null,
  customer_claims: null,
};

// add other docs coporate customer
export const addOtherDocs = createAsyncThunk(
  "/customer/other-docs",
  async (data, thunkAPI) => {
    try {
      return await customerService.addOtherDocs(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// approve Customer
export const approveCustomer = createAsyncThunk(
  "/customer/approve",
  async (data, thunkAPI) => {
    try {
      return await customerService.approveCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// reactivate Customer
export const reactivateCustomer = createAsyncThunk(
  "/customer/reactivate",
  async (id, thunkAPI) => {
    try {
      return await customerService.reactivateCustomer(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// reject Customer
export const rejectCustomer = createAsyncThunk(
  "/customer/reject",
  async (data, thunkAPI) => {
    try {
      return await customerService.rejectCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// close Customer
export const closeCustomer = createAsyncThunk(
  "/customer/close",
  async (data, thunkAPI) => {
    try {
      return await customerService.closeCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update individual customer personal info
export const updateCustomerPersonalInfo = createAsyncThunk(
  "/customer/update-personal-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCustomerPersonalInfo(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update individual customer identity info
export const updateCustomerIdentityInfo = createAsyncThunk(
  "/customer/update-identity-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCustomerIdentityInfo(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update individual customer business info
export const updateCustomerBusinessInfo = createAsyncThunk(
  "/customer/update-business-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCustomerBusinessInfo(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update individual customer nok info
export const updateCustomerNokInfo = createAsyncThunk(
  "/customer/update-nok-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCustomerNokInfo(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update corporate customer business info
export const updateCorporateCustomerBusinessInfo = createAsyncThunk(
  "/customer/update-corporate-business-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCorporateCustomerBusinessInfo(
        customerData
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update corporate customer business info
export const updateCorporateCustomerContactInfo = createAsyncThunk(
  "/customer/update-corporate-contact-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCorporateCustomerContactInfo(
        customerData
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// update corporate customer business info
export const updateCorporateCustomerIdentityInfo = createAsyncThunk(
  "/customer/update-corporate-identity-info",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.updateCorporateCustomerIdentityInfo(
        customerData
      );
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const addIndividualCustomer = createAsyncThunk(
  "/customer/add-individual-customer",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.addIndividualCustomer(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// add corporate customer
export const addCorporateCustomer = createAsyncThunk(
  "/customer/add-corporate-customer",
  async (customerData, thunkAPI) => {
    try {
      return await customerService.addCorporateCustomer(customerData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get all individual customer
export const getIndividualCustomers = createAsyncThunk(
  "getIndividualCustomers",
  async (DATA, thunkAPI) => {
    try {
      return await customerService.getIndividualCustomers(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
// get all corperate customer
export const getCorperateCustomers = createAsyncThunk(
  "getCorperateCustomers",
  async (DATA, thunkAPI) => {
    try {
      return await customerService.getCorperateCustomers(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getSingleCustomer = createAsyncThunk(
  "customer/getSingle",
  async (payload, thunkAPI) => {
    try {
      return await customerService.getSingleCustomer(payload);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const FilteredCorperateCustomers = createAsyncThunk(
  "corperate-customer/filtered-customers",
  async (id, thunkAPI) => {
    try {
      return await customerService.FilteredCorperateCustomers(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// get all individual customer
export const FilteredIndividualCustomers = createAsyncThunk(
  "FilteredIndividualCustomers",
  async (DATA, thunkAPI) => {
    try {
      return await customerService.FilteredIndividualCustomers(DATA);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCorperateCustomersSearch = createAsyncThunk(
  "corperate-customer/searched-customers",
  async (id, thunkAPI) => {
    try {
      return await customerService.getCorperateCustomersSearch(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

// search individual
export const getIndividualCustomersSearch = createAsyncThunk(
  "indivivdual-customer/searched-customers",
  async (id, thunkAPI) => {
    try {
      return await customerService.getIndividualCustomersSearch(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

//get customer active policy details
export const getCustomerActivePolicy = createAsyncThunk(
  "customer/getCustomerActivePolicy",
  async (data, thunkAPI) => {
    try {
      return await customerService.getCustomerActivePolicy(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAttachPolicyCustomer = createAsyncThunk(
  "customer/getAttachPolicyCustomer",
  async (data, thunkAPI) => {
    try {
      return await customerService.getAttachPolicyCustomer(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getCustomerClaims = createAsyncThunk(
  "customer/getCustomerClaims",
  async (data, thunkAPI) => {
    try {
      return await customerService.getCustomerClaims(data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetCustomers: (state) => initialState,
    resetCustomerClaims: (state) => {
      state.customer_claims = null;
    },
    setApplicationType: (state, action) => {
      let { customer_type, isSetCustomerType } = action.payload;
      state.application_info = {
        ...state.application_info,
        customer_type: customer_type,
        isSetCustomerType: isSetCustomerType,
      };
    },
    setApplicationInfo: (state, action) => {
      if (action.payload.other_doc) {
        let payload = action.payload.other_doc;
        if (state.application_info.other_doc) {
          state.application_info = {
            ...state.application_info,
            other_doc: [...state.application_info.other_doc, payload],
          };
        } else {
          state.application_info = {
            ...state.application_info,
            other_doc: [payload],
          };
        }
      } else {
        state.application_info = {
          ...state.application_info,
          ...action.payload,
        };
      }
    },
    setActiveTab: (state, action) => {
      let current_tab = action.payload;
      state.application_info = {
        ...state.application_info,
        current_tab: current_tab,
      };
    },
    resetCustomerStatus: (state) => {
      state.isSuccess = false;
      state.isUpdateSuccess = false;
      state.isLoading = false;
      state.isError = false;
      state.isFiltered = false;
      state.isFiltering = false;
      state.isSearching = false;
      state.isFetching = false;
    },
    resetSingleCustomer: (state) => {
      state.single_customer = {};
    },
    resetAttachPolicyCustomer: (state) => {
      state.attachPolicy_customer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // get all corperate customers
      .addCase(getCorperateCustomers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCorperateCustomers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.isSuccess = true;
        state.customers.corperate = payload;
      })
      .addCase(getCorperateCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all individual customers
      .addCase(getIndividualCustomers.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getIndividualCustomers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        // state.isSuccess = true;
        state.customers.individual = payload.individual;
        state.unpaginated_customers = payload.unpaginated_customers;
      })
      .addCase(getIndividualCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all filtered individual customers
      .addCase(FilteredIndividualCustomers.pending, (state) => {
        state.isLoading = true;
        state.isFiltering = true;
        flash("loading", "Filtering data...");
      })
      .addCase(FilteredIndividualCustomers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isFiltered = true;
        state.isFiltering = false;
        state.customers.individual = payload;
        if (payload.errors) {
          flash("error", payload.errors);
        } else {
          flash("success", payload.message);
        }
      })
      .addCase(FilteredIndividualCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isFiltering = false;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get single customer
      .addCase(getSingleCustomer.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSingleCustomer.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.single_customer = payload.data;
      })
      .addCase(getSingleCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", "Customer cannot be accessed");
      })
      // adding individual customer
      .addCase(addIndividualCustomer.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addIndividualCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isSuccess = true;
          state.application_info = {
            current_tab: "step-1",
            customer_id: "00001",
          };
          state.newCustomer_id = action.payload.customer_id;
          flash("success", "Customer created successfully");
        } else if (typeof action.payload.errors == "string") {
          state.isError = true;
          state.isLoading = false;
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(addIndividualCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update individual customer personal info
      .addCase(updateCustomerPersonalInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateCustomerPersonalInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", "Customer updated successfully");
        } else if (typeof action.payload.errors == "string") {
          state.isError = true;
          state.isSuccess = true;
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateCustomerPersonalInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update individual customer identity info
      .addCase(updateCustomerIdentityInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateCustomerIdentityInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", "Customer updated successfully");
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          flash("error", "Please fill all required fields");
          state.isError = true;
        }
      })
      .addCase(updateCustomerIdentityInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update individual customer business info
      .addCase(updateCustomerBusinessInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateCustomerBusinessInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", "Customer updated successfully");
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        } else if (action.payload.errors) {
          flash("error", "Please fill all required fields");
          state.isError = true;
        }
      })
      .addCase(updateCustomerBusinessInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update individual customer nok info
      .addCase(updateCustomerNokInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(updateCustomerNokInfo.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", "Customer updated successfully");
        }
        if (action.payload.message) {
          state.isSuccess = true;
          flash("success", action.payload.message);
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(updateCustomerNokInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update corporate customer business info
      .addCase(updateCorporateCustomerBusinessInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(
        updateCorporateCustomerBusinessInfo.fulfilled,
        (state, action) => {
          state.isLoading = false;
          if (action.payload.message) {
            state.isError = false;
            state.isUpdateSuccess = true;
            flash("success", "Customer updated successfully");
          } else if (action.payload.error) {
            state.isLoading = false;
            state.isError = true;
            state.message = action.payload.error;
            flash("error", action.payload.error);
          } else if (action.payload.errors) {
            flash("error", "Please fill all required fields");
            state.isError = true;
          }
        }
      )
      .addCase(
        updateCorporateCustomerBusinessInfo.rejected,
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
          flash("error", action.payload);
        }
      )
      // update corporate customer contact info
      .addCase(updateCorporateCustomerContactInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(
        updateCorporateCustomerContactInfo.fulfilled,
        (state, action) => {
          state.isLoading = false;
          if (action.payload.message) {
            state.isSuccess = true;
            state.isError = false;
            state.isUpdateSuccess = true;
            flash("success", action.payload.message);
          } else if (typeof action.payload.errors == "string") {
            flash("error", action.payload.errors);
          } else {
            let key = Object.keys(action.payload.errors)[0];
            let message = action.payload.errors[key][0];
            flash("error", message);
          }
        }
      )
      .addCase(updateCorporateCustomerContactInfo.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // update corporate customer contact info
      .addCase(updateCorporateCustomerIdentityInfo.pending, (state) => {
        flash("info", "Updating...");
        state.isLoading = true;
      })
      .addCase(
        updateCorporateCustomerIdentityInfo.fulfilled,
        (state, action) => {
          state.isLoading = false;
          if (action.payload.message) {
            state.isSuccess = true;
            state.isError = false;
            state.isUpdateSuccess = true;
            flash("success", action.payload.message);
          } else if (typeof action.payload.errors == "string") {
            flash("error", action.payload.errors);
          } else {
            let key = Object.keys(action.payload.errors)[0];
            let message = action.payload.errors[key][0];
            flash("error", message);
          }
        }
      )
      .addCase(
        updateCorporateCustomerIdentityInfo.rejected,
        (state, action) => {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload;
          flash("error", action.payload);
        }
      )
      // approve customer
      .addCase(addOtherDocs.pending, (state) => {
        flash("info", "Adding Document...");
        state.isLoading = true;
      })
      .addCase(addOtherDocs.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", `${action.payload.message}`);
        } else if (action.payload.errors) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.errors;
          flash(
            "error",
            action.payload.errors.other_doc_name ||
              action.payload.errors.other_doc_url
          );
        }
      })
      .addCase(addOtherDocs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // approve customer
      .addCase(approveCustomer.pending, (state) => {
        flash("info", "Approving Customer...");
        state.isLoading = true;
      })
      .addCase(approveCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", `${action.payload.message}`);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(approveCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // reactivate customer
      .addCase(reactivateCustomer.pending, (state) => {
        flash("info", "Reactivating Customer...");
        state.isLoading = true;
      })
      .addCase(reactivateCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", `${action.payload.message}`);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(reactivateCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // reject customer
      .addCase(rejectCustomer.pending, (state) => {
        flash("info", "Rejecting Customer...");
        state.isLoading = true;
      })
      .addCase(rejectCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", `${action.payload.message}`);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(rejectCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // close customer
      .addCase(closeCustomer.pending, (state) => {
        flash("info", "Closing Customer...");
        state.isLoading = true;
      })
      .addCase(closeCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isUpdateSuccess = true;
          flash("success", `${action.payload.message}`);
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(closeCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // adding corporate customer
      .addCase(addCorporateCustomer.pending, (state) => {
        flash("loading", "Creating...");
        state.isLoading = true;
      })
      .addCase(addCorporateCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.message) {
          state.isError = false;
          state.isSuccess = true;
          state.application_info = {
            current_tab: "step-1",
            customer_id: "00001",
          };
          state.newCustomer_id = action.payload.customer_id;
          flash("success", "Customer created successfully");
        } else if (typeof action.payload.errors == "string") {
          flash("error", action.payload.errors);
        } else {
          let key = Object.keys(action.payload.errors)[0];
          let message = action.payload.errors[key][0];
          flash("error", message);
        }
      })
      .addCase(addCorporateCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all customers by filtered parameters
      .addCase(FilteredCorperateCustomers.pending, (state) => {
        flash("loading", "Fetching...");
        state.isLoading = true;
        state.isFiltering = true;
      })
      .addCase(FilteredCorperateCustomers.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          state.isFiltering = true;
          state.isFiltered = true;
          state.customers.corperate = action.payload;
          flash("success", "Request successful");
        } else if (action.payload.error) {
          state.isLoading = false;
          state.isFiltering = false;
          state.isFiltered = true;
          state.isError = true;
          state.message = action.payload.error;
          flash("error", action.payload.error);
        }
      })
      .addCase(FilteredCorperateCustomers.rejected, (state, action) => {
        state.isLoading = false;
        state.isFiltered = true;
        state.isFiltering = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all corperate customers by  searched parameter
      .addCase(getCorperateCustomersSearch.pending, (state) => {
        flash("loading", "Fetching...");
        state.isLoading = true;
        state.isSearching = true;
      })
      .addCase(getCorperateCustomersSearch.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          state.isSearching = false;
          state.isFiltered = true;
          state.customers.corperate = action.payload;
          if (action.payload.errors) {
            flash("error", action.payload.errors);
          } else {
            flash("success", "Request successful");
          }
        }
      })
      .addCase(getCorperateCustomersSearch.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all individual customers by  searched parameter
      .addCase(getIndividualCustomersSearch.pending, (state) => {
        flash("loading", "Fetching...");
        state.isLoading = true;
        state.isSearching = true;
      })
      .addCase(getIndividualCustomersSearch.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          // state.isSuccess = true;
          state.isSearching = false;
          state.isFiltered = true;
          state.customers.individual = action.payload;
          if (action.payload.errors) {
            flash("error", action.payload.errors);
          } else {
            flash("success", "Request successful");
          }
        }
      })
      .addCase(getIndividualCustomersSearch.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      // get all individual customers by  searched parameter
      .addCase(getAttachPolicyCustomer.pending, (state) => {
        flash("info", "Fetching...");
        state.isLoading = true;
        state.isSearching = true;
      })
      .addCase(getAttachPolicyCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload) {
          state.isSuccess = true;
          state.isSearching = false;
          state.isFiltered = true;
          state.attachPolicy_customer = action.payload.attach_policy_customer;
          if (action.payload.errors) {
            flash("error", action.payload.errors);
          } else {
            flash("success", "Search successful");
          }
        }
      })
      .addCase(getAttachPolicyCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(getCustomerActivePolicy.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getCustomerActivePolicy.fulfilled, (state, action) => {
        state.isFetching = false;
        if (action.payload) {
          state.isSuccess = true;
          state.customer_active_policy = action.payload.customer_with_policy;
          if (action.payload.errors) {
            flash("error", action.payload.errors);
          }
        }
      })
      .addCase(getCustomerActivePolicy.rejected, (state, action) => {
        state.isFetching = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      })
      .addCase(getCustomerClaims.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCustomerClaims.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        if (payload) {
          state.isSuccess = true;
          state.customer_claims = payload;
          if (!payload.errors) {
            state.isSuccess = true;
            flash("success", payload.message);
          } else if (typeof payload.errors == "string") {
            flash("error", payload.errors);
          } else {
            let key = Object.keys(payload.errors)[0];
            let message = payload.errors[key][0];
            flash("error", message);
          }
        }
      })
      .addCase(getCustomerClaims.rejected, (state, action) => {
        state.isFetching = false;
        state.isError = true;
        state.message = action.payload;
        flash("error", action.payload);
      });
  },
});

export const {
  resetCustomers,
  setApplicationType,
  setApplicationInfo,
  setActiveTab,
  resetCustomerStatus,
  resetSingleCustomer,
  resetAttachPolicyCustomer,
  resetCustomerClaims,
} = customerSlice.actions;
export default customerSlice.reducer;
